import { render, staticRenderFns } from "./ThreatTable.vue?vue&type=template&id=d99a06a8"
import script from "./ThreatTable.vue?vue&type=script&lang=js"
export * from "./ThreatTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports